export default "__VITE_ASSET__D3W8XsxH__"